import { c as _c } from "react/compiler-runtime";
import React, { useCallback, useState } from 'react';
import PropTypes from 'prop-types';
import { ZIP_CODE_REGEX } from 'commons/constants';
import { BANNER_IMAGE_URL } from './helpers';
const INVALID_ZIP_MESSAGE = 'Please enter a 5-digit zip code.';
const StoreLocatorSearch = t0 => {
  const $ = _c(27);
  const {
    zipcode,
    onZipcodeChange,
    onSearch,
    onViewAll
  } = t0;
  const [error, setError] = useState("");
  let t1;
  if ($[0] !== error || $[1] !== onZipcodeChange) {
    t1 = event => {
      onZipcodeChange(event.target.value);
      if (error) {
        setError("");
      }
    };
    $[0] = error;
    $[1] = onZipcodeChange;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const handleZipChange = t1;
  let t2;
  if ($[3] !== onSearch || $[4] !== onViewAll || $[5] !== zipcode) {
    t2 = event_0 => {
      event_0.preventDefault();
      const trimmed = zipcode.trim();
      if (!trimmed) {
        setError("");
        onViewAll();
        return;
      }
      if (!ZIP_CODE_REGEX.test(trimmed)) {
        setError(INVALID_ZIP_MESSAGE);
        return;
      }
      setError("");
      onSearch(trimmed);
    };
    $[3] = onSearch;
    $[4] = onViewAll;
    $[5] = zipcode;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  const handleSubmit = t2;
  let t3;
  let t4;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      backgroundImage: `url(${BANNER_IMAGE_URL})`
    };
    t4 = <div className="absolute inset-0 bg-black/40" />;
    $[7] = t3;
    $[8] = t4;
  } else {
    t3 = $[7];
    t4 = $[8];
  }
  let t5;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <span className="text-base font-bold text-white whitespace-nowrap md:py-2">Find Showroom</span>;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  const t6 = error ? "true" : "false";
  const t7 = error ? "store-locator-zipcode-error" : undefined;
  let t8;
  if ($[10] !== handleZipChange || $[11] !== t6 || $[12] !== t7 || $[13] !== zipcode) {
    t8 = <input id="store-locator-zipcode" name="zipcode" type="text" inputMode="numeric" placeholder="Zip Code" aria-label="Zip code" aria-invalid={t6} aria-describedby={t7} value={zipcode} onChange={handleZipChange} maxLength="5" autoComplete="postal-code" className="flex-1 min-w-0 px-3 py-2 bg-white text-base text-gray-dark placeholder-gray-light3 outline-none focus:ring-2 focus:ring-brand" />;
    $[10] = handleZipChange;
    $[11] = t6;
    $[12] = t7;
    $[13] = zipcode;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  let t9;
  if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <button type="submit" className="px-6 bg-brand text-white text-base whitespace-nowrap hover:bg-gray-dark transition-colors">Search</button>;
    $[15] = t9;
  } else {
    t9 = $[15];
  }
  let t10;
  if ($[16] !== t8) {
    t10 = <div className="flex items-stretch min-w-0">{t8}{t9}</div>;
    $[16] = t8;
    $[17] = t10;
  } else {
    t10 = $[17];
  }
  let t11;
  if ($[18] !== error) {
    t11 = error && <div id="store-locator-zipcode-error" role="alert" className="mt-1 text-sm text-white bg-red/80 px-2 py-1 rounded-sm">{error}</div>;
    $[18] = error;
    $[19] = t11;
  } else {
    t11 = $[19];
  }
  let t12;
  if ($[20] !== onViewAll) {
    t12 = <div className="mt-2"><button type="button" onClick={onViewAll} className="text-sm text-white underline hover:text-gray-light6">View All</button></div>;
    $[20] = onViewAll;
    $[21] = t12;
  } else {
    t12 = $[21];
  }
  let t13;
  if ($[22] !== handleSubmit || $[23] !== t10 || $[24] !== t11 || $[25] !== t12) {
    t13 = <div className="relative w-full h-56 bg-center bg-cover" style={t3}>{t4}<div className="relative z-10 flex flex-col items-center justify-center h-full px-4"><div className="w-full max-w-2xl flex flex-col md:flex-row md:items-start gap-2 md:gap-4">{t5}<form onSubmit={handleSubmit} className="flex flex-1 flex-col min-w-0">{t10}{t11}{t12}</form></div></div></div>;
    $[22] = handleSubmit;
    $[23] = t10;
    $[24] = t11;
    $[25] = t12;
    $[26] = t13;
  } else {
    t13 = $[26];
  }
  return t13;
};
StoreLocatorSearch.propTypes = {
  zipcode: PropTypes.string.isRequired,
  onZipcodeChange: PropTypes.func.isRequired,
  onSearch: PropTypes.func.isRequired,
  onViewAll: PropTypes.func.isRequired
};
export default StoreLocatorSearch;